export default __webpack_public_path__ + "static/media/html.d7ce5647.svg";